<template>
  <div class="container">
    <div class="">
      <div class="row mb-2">
        <div v-for="(categoria, index) in clienteCategorias.categorias" class="col-12 col-md-5 col-lg-4 p-0">
          <div class="card mb-4">
            <a v-bind:href="'/' + clienteCategorias.clientes.slug + '/'+categoria.slug"
               class="text-justify text-md-center ml-5 pl-3 ml-md-0 pl-md-0 font-weight-normal"
               :style="estilo.grupoCategorias">
              <img :src="'https://'+categoria.iconos[0].url_icono" alt="" v-if="categoria.iconos.length != 0"
                   width="32px" height="32px">
              <span class="pl-3"
                    :style="{'font-size': estilo.grupoCategorias['font-size']+'px', color: estilo.grupoCategorias.color}">{{ categoria.categoria }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import list_ApiUrl from '../../compartida/listApiUrl';

  export default {
    name: "grupoCategoriasPublic",
    data() {
      return {
        clienteCategorias: {},
        estilo: {
          grupoCategorias: {'font-size': '0', color: '#000'}
        }
      }
    },
    created() {
      let cliente = this.$route.params.cliente;
      EventBus.$emit('nombreSlugCliente', cliente);
      EventBus.$on('paginaInicio', this.estilos);
      this.cargarGrupocategorias(cliente)
    },
    methods: {
      estilos: function (data) {
        // console.log(43 + ' Estilos grupoCategorias', data.grupoCategorias);
        this.estilo.grupoCategorias = data.grupoCategorias;
      },
      cargarGrupocategorias(cliente) {
        axios.get(`${list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.API_URL_PUBLICO + list_ApiUrl.API_URL_PUBLICO_CLIENTE}/${cliente}`)
          .then(response => {
            this.clienteCategorias = response.data.data;
            EventBus.$emit('nombreEmpresa', response.data.data.clientes.nombre);
          }).catch(e => {
          console.log(e);
        });
      }
    }
  }
</script>

<style scoped lang="scss">
  .card, .card-body, .car-footer {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.0), 0 0 0 0 rgba(0, 0, 0, .0), 0 0 0 0 rgba(0, 0, 0, .0);
    -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.0), 0 0 0 0 rgba(0, 0, 0, .0), 0 0 0 0 rgba(0, 0, 0, .0);
  }

  .card-footer {
    border-top: 1px solid rgba(0, 0, 0, .0);
  }

  .circulo {
    height: 15px;
    width: 15px;
    border: 3px solid #4EA9E0;
    border-radius: 50px;
    display: inline-block;
  }

</style>



// WEBPACK FOOTER //
// src/components/publico/fragmentosInicio/grupoCategorias.vue